import { OptionTuple } from '~/components/Input/Select/Select';
import { ForwardedRef, forwardRef, useMemo } from 'react';
import { useCompetitionLevelListQuery } from '../queries';
import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'>;

function CompetitionLevelSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data = [], isLoading } = useCompetitionLevelListQuery({
    permission_to_create: true,
  });

  const options = useMemo<OptionTuple[]>(() => {
    return data.map(level => [level.description, level.name]);
  }, [data]);

  return (
    <Input.Select
      placeholder={props.placeholder ?? 'Alla nivåer'}
      disabled={isLoading || props.disabled}
      options={options}
      ref={ref}
      {...props}
    />
  );
}

export const CompetitionLevelSelect = forwardRef(CompetitionLevelSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof CompetitionLevelSelectElement>;
